<template>
<el-row>
<el-col :span="24" style="padding-left: 16px">
    <el-card style="width:100%">
    <el-table
        width="100%"
        :data="sessions"
        :empty-text="$t('Активных сессий нет')"
    >
        <el-table-column
            :label="$t('Название сессии')"
            class-name="element-top"
        >
            <template #default="scope">
                <span class="cell-custom"> 
                    {{scope.row.caseName}}
                </span>
             </template>
       </el-table-column>
        
        <el-table-column
            :label="$t('Текущие сессии')"
            class-name="element-top"
        >
            <template #default="scope">
                <el-button size="small" @click="deleteUserSessions(scope.row)">
                    {{ $t('Сбросить') }}
                </el-button>
            </template>
        </el-table-column>
    </el-table>
    </el-card>
</el-col>
</el-row>
</template>
<script>
import { ElNotification } from 'element-plus';
import SessionsController from "../../controllers/sessions.controller";

export default {
    name: "Sessions",
    data() {
        return {
            sessions: [],
             notification: {
                deleteSession: null,
                deleteSessionError: null,
            },
        }
    },

    mounted() {
        this.sessionsController = new SessionsController();
        this.getUserSessions();
        this.notification.deleteSession = () => {
            ElNotification({
                title: this.$t('Выполнено'),
                type: 'success',
                duration: 3000,
                position: 'bottom-right',
                message: this.$t('Прогресс успешно удален'),
             });
        this.notification.deleteSessionError = () => {
            ElNotification({
                title: this.$t('Ошибка'),
                type: 'error',
                duration: 3000,
                position: 'bottom-right',
                message: this.$t('Ошибка во время удаления'),
             });
            };
        };
    },

    methods: {
        showNotification(obj) {
            this.notification[obj.name](obj.agrs);
        },

        getUserSessions() {
            const userId = this.$route.params.id;
            this.sessionsController.getUserSessions(userId).then((res)=> {
                this.sessions = res.data
            });
        },
        deleteUserSessions(row) {
            this.sessionsController.deleteUserSessions(row._id).then(()=> {
                this.showNotification({
                    name: 'deleteSession',
                    agrs: { text: this.$t('Прогресс успешно удален') },
                })
            });
        },
    },
}
</script>